// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddManager_container__qritY {
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 50%;
}

.AddManager_header__XPO5e {
  display: flex;
  justify-content: space-between;
}

.AddManager_header__XPO5e h3 {
  margin: 0;
}

.AddManager_header__XPO5e span {
  cursor: pointer;
}

.AddManager_formElement__Zb89L {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 8px 16px;
  flex: 1 1;
}

.AddManager_formElement__Zb89L label {
  color: rgba(27, 31, 59, 0.65);
  font-size: 14px;
}

.AddManager_formElement__Zb89L input,
.AddManager_formElement__Zb89L select {
  border: none;
  color: #121b3f;
  font-size: 1rem;
}

.AddManager_form__7c7kQ {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.AddManager_form__7c7kQ button {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  padding: 0 16px;
  border: none;
  background-color: #3082f6;
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
}

.AddManager_form__7c7kQ button:disabled {
  background-color: #8cb6f1;
  cursor: not-allowed;
}

.AddManager_elements__EphEq {
  display: flex;
  gap: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/addManager/AddManager.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".container {\n  background-color: white;\n  padding: 32px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 50%;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.header h3 {\n  margin: 0;\n}\n\n.header span {\n  cursor: pointer;\n}\n\n.formElement {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border: 1px solid #ededed;\n  border-radius: 12px;\n  padding: 8px 16px;\n  flex: 1;\n}\n\n.formElement label {\n  color: rgba(27, 31, 59, 0.65);\n  font-size: 14px;\n}\n\n.formElement input,\n.formElement select {\n  border: none;\n  color: #121b3f;\n  font-size: 1rem;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.form button {\n  width: 100%;\n  height: 44px;\n  border-radius: 12px;\n  padding: 0 16px;\n  border: none;\n  background-color: #3082f6;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.2s ease;\n}\n\n.form button:disabled {\n  background-color: #8cb6f1;\n  cursor: not-allowed;\n}\n\n.elements {\n  display: flex;\n  gap: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddManager_container__qritY`,
	"header": `AddManager_header__XPO5e`,
	"formElement": `AddManager_formElement__Zb89L`,
	"form": `AddManager_form__7c7kQ`,
	"elements": `AddManager_elements__EphEq`
};
export default ___CSS_LOADER_EXPORT___;
